import MainConnection from "./MainConnection";

export default {
  requestSignIn: async function(params) {
    try {
      const requestURL = "/signin";
      const response = await MainConnection.request().post(requestURL, params);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestSignUp: async function(params) {
    try {
      const requestURL = "/signup";
      const response = await MainConnection.request().post(requestURL, params);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestChangePassword: async function(params) {
    try {
      const requestURL = "/change_password";
      const response = await MainConnection.request().post(requestURL, params);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestResetPassword: async function(params) {
    try {
      const requestURL = "/set_password";
      const response = await MainConnection.request().post(requestURL, params);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestCreateNewUser: async function(params) {
    try {
      const requestURL = "/user/create";
      const response = await MainConnection.request().post(requestURL, params);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestUserList: async function() {
    try {
      const requestURL = "/user/all";
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestUserInfoById: async function(user_id) {
    try {
      const requestURL = "/user/" + user_id;
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestUpdateUserInfoById: async function(user_id, params) {
    try {
      const requestURL = "/user/" + user_id;
      const response = await MainConnection.request().patch(requestURL, params);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestRemoveUserInfoById: async function(user_id) {
    try {
      const requestURL = "/user/" + user_id;
      const response = await MainConnection.request().delete(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
